import * as React from 'react';
import { SVGProps } from 'react';

const IconPipetteSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.214.96c.454.051.942.196 1.286.54.344.343.488.832.54 1.286.09.79-.34 1.514-.901 2.075L9 6l1 1-1 1-1-1-2.57 2.57-.175.166A4.885 4.885 0 0 1 1.977 11l-.1-.005a.977.977 0 0 1-.872-.872l-.005-.1c0-1.214.452-2.382 1.264-3.278l.167-.176L5 4 4 3l1-1 1 1 1.139-1.138C7.7 1.3 8.425.871 9.214.96ZM3.138 7.276A3.885 3.885 0 0 0 2 10c1.022-.006 2-.414 2.724-1.137l2.569-2.57-1.586-1.585-2.57 2.57Z"
    />
  </svg>
);
export default IconPipetteSizeXs;
